/*
 * 绑定手机的modal
 */
import Menu, { MenuItem } from '@/components/Menu/';
import Dropdown from '@/components/Dropdown/Dropdown';
import Message from '@/components/Message';
import Icon from '@/components/Icon/Icon';
import Modal from '@/components/Modal/';
import { noop } from '@/utils/util';
import Ajax from '@/utils/ajax';
import loadingImg from '@/assets/images/tiny.gif';
import { User } from '@/constants/actionTypes';
import NestLoading from '@/components/Loading/NestLoading';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Immutable from 'immutable';
import classNames from 'classnames';
import i18n from 'react-intl-universal';
import styles from './PhoneModal.scss';

const countryOtpInfos = []; // 国家区号信息

@connect(
  state => ({}),
  dispatch => ({}),
)
export default class PhoneModal extends Component {
  static defaultProps = {
    onModalCancelClick: noop,
    onModalConfirmBtnClick: noop,
  }

  constructor(props) {
    super(props);
    this.state = {
      error: '',
      confirming: false, // 正在验证验证码
      sending: false, // 正在请求发送验证吗
      callingCode: '86', // 手机号码国家区号代码
      isoCode: 'CN', // 手机号码国家区号代码
      curChannel: 'sms',
      curSecond: 0, // 倒计时秒数
      isResendCaptcha: false, // 是否是重发验证码
      countryPhoneData: {}, // 国家区号
    };
    // console.log('getCountyOtpInfo::', countryOtpInfos);

    if (countryOtpInfos.length < 1) {
      Ajax.getCountyOtpInfo()
        .then(({ data }) => {
          this.setState({
            countryPhoneData: data,
          });
        })
        .catch(() => {
          Message.error(i18n.get('phoneModal.get-otp-info-error'));
        });
    }
  }

  startConutDown = (total) => {
    clearInterval(this.captchaTimer);
    this.setState({
      curSecond: total,
    });
    this.captchaTimer = setInterval(() => {
      let { curSecond, isResendCaptcha } = this.state;
      curSecond -= 1;
      if (curSecond <= 0) {
        clearInterval(this.captchaTimer);
        curSecond = 0;
        isResendCaptcha = true;
      }
      this.setState({ curSecond, isResendCaptcha });
    }, 1000);
  }
  onCountryDropdownItemClick = (e, data = {}) => {
    if (data.index) {
      const { isoCode, callingCode } = data.index;
      this.setState({
        isoCode,
        callingCode,
      });
      document.body.click(); // close the drop menu
    }
  }
  sendCaptchaBtnClick = () => {
    const { isoCode, curSecond, sending } = this.state;
    const phoneNum = this.getPhoneNum();
    if (!phoneNum) {
      return;
    }
    if (curSecond || sending) {
      return;
    }
    this.setState({ sending: true });
    Ajax.sendCaptchaWhenBindPhone({
      iso_code: isoCode,
      mobile_number: phoneNum,
    }).then(() => {
      this.startConutDown(60);
      this.setState({ sending: false });
    })
      .catch((...args) => {
        Message.error(i18n.get('verifymodal.send-captcha-error'));
        this.setState({ sending: false });
      });
  }
  getCountryDropItems = () => {
    const { countryPhoneData } = this.state;
    const allCountries = countryPhoneData.all_countries;
    const importantCountries = countryPhoneData.important_countries;
    if (!importantCountries || !allCountries) {
      return null;
    }
    const data = ['divider-hot'].concat(importantCountries).concat('divider-all', allCountries);
    return (
      data.map((v, k) => {
        if (v === 'divider-hot') {
          return (
            <div key={k} className={styles['divider']}>{i18n.get('phoneModal.hot-countries')}</div>
          );
        }
        if (v === 'divider-all') {
          return (
            <div key={k} className={styles['divider']}>{i18n.get('phoneModal.all')}</div>
          );
        }
        return (
          <MenuItem key={k} index={{ isoCode: v.iso_code, callingCode: v.calling_code }}>
            <span>+{v.calling_code}</span>{v.name}
          </MenuItem>
        );
      })
    );
  }
  getPhoneNum = () => {
    const phoneNum = (this.phoneInput.value || '').trim();
    if (!/^\d{11}$/.test(phoneNum)) {
      Message.error(i18n.get('phoneModal.phone-error'));
      return '';
    }
    return phoneNum;
  }
  onModalConfirmBtnClick = () => {
    const { onModalConfirmBtnClick } = this.props;
    const { isoCode, callingCode, confirming } = this.state;
    const code = (this.codeInput.value || '').trim();
    const phoneNum = this.getPhoneNum();
    if (!phoneNum) {
      return;
    }
    if (!/^\d{6}$/.test(code)) {
      Message.error(i18n.get('phoneModal.captcha-regex-error'));
      return;
    }
    if (confirming) {
      return;
    }
    this.setState({
      confirming: true,
    });
    Ajax.bindPhone({
      mobile_number: phoneNum,
      iso_code: isoCode,
      code,
    }).then(() => {
      this.setState({
        confirming: false,
      });
      onModalConfirmBtnClick({ phone: phoneNum });
    }).catch((res = {}) => {
      this.setState({
        confirming: false,
      });
      Message.error((res.error && res.error[0].message) || i18n.get('error.try-again'));
    });
  }

  render() {
    const {
      countryPhoneData,
      isResendCaptcha,
      curSecond,
      callingCode,
      confirming,
    } = this.state;
    const { onModalCancelClick, visible } = this.props;
    const sendBtnClass = classNames(styles['btn-in-resend'], {
      [styles['disable']]: !!curSecond,
    });
    let captchaBtnTip = 'verifymodal.send-captcha';
    if (curSecond) {
      captchaBtnTip = 'verifymodal.sending-captcha';
    } else if (isResendCaptcha) {
      captchaBtnTip = 'verifymodal.resend-captcha';
    }
    return (
      <Modal
        width={420}
        visible={visible}
        showFooter={false}
        maskClassName={styles['mask']}
        modalClassName={styles['modal']}
        closable
        isMiddle
        title={i18n.get('phoneModal.title')}
        onCancel={onModalCancelClick}
      >
        <form className={styles['form']}>
          <div className={classNames(styles['input-prepend'], styles['phone-input-prepend'])}>
            <input
              type="text"
              pattern="\d*"
              maxLength="11"
              placeholder={i18n.get('phoneModal.phone-num')}
              ref={(v) => {
                this.phoneInput = v;
              }}
            />
          </div>
          <div className={classNames(styles['input-prepend'], styles['captcha-input-prepend'])}>
            <Icon name='shield' size='lg'/>
            <input
              type="text"
              placeholder={i18n.get('phoneModal.captcha')}
              maxLength='6'
              ref={(v) => {
                this.codeInput = v;
              }}
            />
            <a className={sendBtnClass} onClick={this.sendCaptchaBtnClick}>
              {i18n.get(captchaBtnTip, { num: curSecond })}
            </a>
          </div>
          <div
            className={styles['confirm-btn']}
            onClick={this.onModalConfirmBtnClick}
          >
            {confirming ? i18n.get('verifymodal.confirming') : i18n.get('verifymodal.confirm')}
          </div>
        </form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PhoneModal/PhoneModal.js